export default __webpack_public_path__ + "static/media/blog_detail3.f29c679d.webp";